import { render, staticRenderFns } from "./PriceMarketTable.vue?vue&type=template&id=0d4ad086&scoped=true&"
import script from "./PriceMarketTable.vue?vue&type=script&lang=js&"
export * from "./PriceMarketTable.vue?vue&type=script&lang=js&"
import style0 from "./PriceMarketTable.vue?vue&type=style&index=0&id=0d4ad086&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4ad086",
  null
  
)

export default component.exports